<div class="item-setting-container">
  <div class="filter-section text-right">
    <button (click)='saveSettings()' mat-flat-button color="" class="btn-primary"
      [disabled]='isPublished || (roleSer.accessData?!roleSer.accessData.insertAllowed || !roleSer.accessData.updateAllowed :true)'>{{'itemDetails.TabSettings.btnSave' | translate}}</button>
  </div>
  <div class="container-fluid">
    <div class="row">
      <div class="col-md-4">
        <label for="" class="lableH">{{'itemDetails.TabSettings.label1' | translate}}</label>
        <div class="autoC">
          <form>
            <mat-form-field appearance="fill">
              <mat-select [(value)]="defaultStatus" #selectList (selectionChange)="updateStatus(selectList.value)"
                [disabled]='isPublished || (roleSer.accessData? !roleSer.accessData.insertAllowed:true || roleSer.accessData? !roleSer.accessData.updateAllowed:true)'>
                <mat-option *ngFor="let status of selectStatus" [value]="status?.itemStatusId">
                  <p>{{status?.itemStatus}} </p>
                </mat-option>
              </mat-select>
            </mat-form-field>
          </form>
        </div>
      </div>
      <div class="col-md-4">
        <label for="" class="lableH">{{'itemDetails.TabSettings.label2' | translate}}</label>
        <div class="autoC">
          <form>
            <mat-form-field appearance="fill">
              <mat-select [(value)]="selectedLevelID"
                [disabled]='isPublished || (roleSer.accessData? !roleSer.accessData.insertAllowed:true || roleSer.accessData? !roleSer.accessData.updateAllowed:true)'>
                <mat-option *ngFor="let level of selectLevels" [value]="level?.difficultyLevelId">
                  <p (click)="this.selectedLevelID = level?.difficultyLevelId">{{level?.difficultyLevelId}}</p>
                </mat-option>
              </mat-select>
            </mat-form-field>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>
